import { IApplicationState } from '../../types/redux';

export const getBreadcrumbs = (state: IApplicationState) => {
  return state.offersData.breadcrumbs;
};
